import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultEmergencyPreparednessQuestionnaire = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultEmergencyPreparednessQuestionnaire' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <b> <center> Emergency Preparedness Questionnaire  </center> </b>
                </p>
                <p className='w-750'>
                    Please provide us with your updated emergency contact information and contact information of your evacuation destination.
                </p>
                <table>

                    <tr>
                        <td className='w-375'> <span className='eleHeader'>EMPLOYEE/ CLIENT Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Phone Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtEmployeeClientName' name='txtEmployeeClientName' type='text' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtEmployeeClientPhone' name='txtEmployeeClientPhone' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>  <input id='txtEmployeeClientAddress' name='txtEmployeeClientAddress' type='text' className='add-only' /> </td>
                    </tr>


                    <tr>
                        <td className='w-375'> <span className='eleHeader'>EMERGENCY/ CONTACT Name:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Phone Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtEmergencyContactName' name='txtEmergencyContactName' type='text' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtEmergencyContactPhone' name='txtEmergencyContactPhone' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>  <input id='txtEmergencyContactAddress' name='txtEmergencyContactAddress' type='text' className='add-only' /> </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Do you have somewhere to evacuate?</span>
                    <input type='radio' id='rbSomewhereToEvacuate_Yes' name='rbSomewhereToEvacuate' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSomewhereToEvacuate_No' name='rbSomewhereToEvacuate' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Do you plan to evacuate?</span>
                    <input type='radio' id='rbPlanToEvacuate_No' name='rbPlanToEvacuate' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbPlanToEvacuate_Yes' name='rbPlanToEvacuate' className='add-only' value='Yes' /> Yes
                    Who will evacuate with you? <input type='text' id='txtPlanToEvacuate_WhoWill' name='txtPlanToEvacuate_WhoWill' className='add-only w-200 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Do you plan to return? </span>
                    <input type='radio' id='rbPlanToReturn_No' name='rbPlanToReturn' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbPlanToReturn_Yes' name='rbPlanToReturn' className='add-only' value='Yes' /> Yes
                    If so, when? <input type='text' id='txtPlanToReturnWhen' name='txtPlanToReturnWhen' className='add-only w-200 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Do you have the necessities to evacuate?</span>
                    <input type='radio' id='rbNecessitiesToEvacuate_Yes' name='rbNecessitiesToEvacuate' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNecessitiesToEvacuate_No' name='rbNecessitiesToEvacuate' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Do you currently own a cell phone?</span>
                    <input type='radio' id='rbCurrentlyOnaCellPhone_Yes' name='rbCurrentlyOnaCellPhone' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbCurrentlyOnaCellPhone_No' name='rbCurrentlyOnaCellPhone' className='add-only' value='No' /> No
                    If not, whom can we contact to reach you immediately  <input type='text' id='txtCurrentlyOnaCellPhoneWhomWeconnect' name='txtCurrentlyOnaCellPhoneWhomWeconnect' className='add-only w-200 custom-add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>What is the best way to contact you? </span>
                    <span className='small'>(Circle All That Apply) </span>
                    <input type='checkbox' id='cbBestWayToContact_Phone' name='cbBestWayToContact_Phone' className='add-only' value='Phone' /> Phone  &nbsp;
                    <input type='checkbox' id='cbBestWayToContact_Text' name='cbBestWayToContact_Text' className='add-only' value='Text' /> Text &nbsp;
                    <input type='checkbox' id='cbBestWayToContact_Email' name='cbBestWayToContact_Email' className='add-only' value='Email' /> Email &nbsp;
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Any additional information/ comments:</span>
                    <textarea id='txtAnyAdditionalInformation' name='txtAnyAdditionalInformation' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Louisiana Emergency Preparedness Guide Received?</span>
                    <input type='radio' id='rbLouisianaEmergencyPreparednessGuideReceived_Yes' name='rbLouisianaEmergencyPreparednessGuideReceived' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbLouisianaEmergencyPreparednessGuideReceived_No' name='rbLouisianaEmergencyPreparednessGuideReceived' className='add-only' value='No' /> No
                    If not, whom can we contact to reach you immediately  <input type='text' id='txtLouisianaEmergencyPreparednessGuideReceivedContactPerson' name='txtLouisianaEmergencyPreparednessGuideReceivedContactPerson' className='add-only w-200 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}